// file path: src\App.tsx

import React from 'react';
import './custom.less';  // Import custom Less file

import AuthGuard from './Components/AuthGuard';
import { Provider } from 'react-redux';
import { store } from './stores/app.store';






const App = () => {
  return (
    <Provider store={store}>
      <AuthGuard />
    </Provider>
  );
};

export default App;
